import React, { useEffect, useRef } from 'react'
import AniLink from 'gatsby-plugin-transition-link/AniLink'
import * as E from '../../elementor'
import Card from './Card'
import SwiperNext from '../../images/swiper-right.svg'
import SwiperPrev from '../../images/swiper-left.svg'
import { register } from 'swiper/element/bundle'

import 'swiper/scss'
import 'swiper/scss/scrollbar'
import 'swiper/scss/navigation'
import SmoothScrollLink from '../transition/smooth-scroll-link'
import CardCondensed from './CardCondensed'
register()

type Props = {
  section: E.Section<true>
  template?: string
}

const HowItWorksTofu = ({ section, template }: Props) => {
  const { button, slides, heading, textEditor } = E.collect(section)
  const slideGroup = slides[0]?.slides

  const swiperRef = useRef(null)
  const nextRef = useRef(null)
  const prevRef = useRef(null)

  useEffect(() => {
    const swiperContainer = swiperRef.current
    const params = {
      slidesPerView: slideGroup.length === 3 ? 3 : 4,
      spaceBetween: 24,
      scrollbar: true,
      mousewheel: {
        forceToAxis: true,
      },
      navigation: false,
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 16,
          centeredSlides: true,
        },
        400: {
          slidesPerView: 1.15,
          spaceBetween: 16,
          centeredSlides: true,
        },
        500: {
          slidesPerView: 1.4,
          spaceBetween: 16,
          centeredSlides: false,
        },
        700: {
          slidesPerView: 2,
          spaceBetween: 16,
          navigation: {
            nextEl: nextRef.current,
            prevEl: prevRef.current
          },
        },
        1000: {
          slidesPerView: 3,
          spaceBetween: 16,
          navigation: {
            nextEl: nextRef.current,
            prevEl: prevRef.current
          },
        },
        1300: {
          slidesPerView: slideGroup.length === 3 ? 3 : 4,
          spaceBetween: 24,
          navigation: {
            nextEl: nextRef.current,
            prevEl: prevRef.current
          },
        }
      },
      injectStyles: [
        `
        .swiper-wrapper {
          margin-bottom: 2rem;
        }
        .swiper-scrollbar {
          background: #f5f5f5;
        }
        .swiper-scrollbar.swiper-scrollbar-horizontal {
          height: 2px;
        }
        .swiper-scrollbar-drag {
          background: #262626;
        }
      `
      ]
    }

    if (swiperContainer !== undefined && swiperContainer !== null) {
      Object.assign(swiperContainer, params);
      (swiperContainer as any).initialize()
    }
  }, [])

  let imageSize = 'three-two'
  if (slideGroup.length === 3) {
    imageSize = 'two-one'
  }

  const hasCta = button.length > 0
  const ctaIsScrollLink = button[0]?.link !== undefined && button[0]?.link.includes('#')

  return (
    <section>
      <div className='how-it-works-tofu-wrapper'>
        <div className='cta-wrapper'>
          <div className='title-wrapper'>
            <h2 className='subhead s4'>{textEditor[0]?.text()}</h2>
            <h3 className='heading'>{heading[0]?.title}</h3>
          </div>
        </div>
        <div className='cards-wrapper'>
          <button ref={prevRef} className='swipe-prev' aria-label='Previous slide' style={{ backgroundImage: `url(${SwiperPrev})`}} />
          <swiper-container slidesPerView='4' ref={swiperRef} init='false'>
            {slideGroup.map((slide, index) => {
              return <CardCondensed slide={slide} slideNumber={index+1} key={index} />
            })}
          </swiper-container>
          <button ref={nextRef} className='swipe-next' aria-label='Next slide' style={{ backgroundImage: `url(${SwiperNext})`}} />
        </div>
        <div className='tofu-cta-wrapper'>
          {hasCta ? 
            ctaIsScrollLink ? 
            <SmoothScrollLink className='cta-button' offset={0} offsetMobile={0} id={button[0]?.link as string}><button className='rula-button'>{button[0]?.text}</button></SmoothScrollLink> :
            <AniLink id={button[0]?.button_css_id || ''} className='cta-button' to={button[0]?.link} fade><button className='rula-button'>{button[0]?.text}</button></AniLink>
          : null}
        </div>
      </div>
    </section>
  )
};

export default HowItWorksTofu
